var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10V9C11 8.0681 10.3626 7.28505 9.5 7.063M7.75 1.14538C8.48295 1.44208 9 2.16066 9 3C9 3.83934 8.48295 4.55795 7.75 4.8546M8.5 10C8.5 9.0681 8.5 8.6022 8.34775 8.23465C8.14475 7.7446 7.7554 7.35525 7.26535 7.15225C6.8978 7 6.4319 7 5.5 7H4C3.06811 7 2.60218 7 2.23464 7.15225C1.74458 7.35525 1.35523 7.7446 1.15224 8.23465C1 8.6022 1 9.0681 1 10M6.75 3C6.75 4.10457 5.85455 5 4.75 5C3.64543 5 2.75 4.10457 2.75 3C2.75 1.89543 3.64543 1 4.75 1C5.85455 1 6.75 1.89543 6.75 3Z",
    stroke: "#4A5565",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users_icon.0c1f3fa132027c11831018af20c9243a.svg";
export { ForwardRef as ReactComponent };